import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import styled from 'styled-components';
import React, { forwardRef, useEffect } from 'react';
import { CommentExtension } from '../extensions/comment';
import { styleVariables } from '../../../style';
import { useCommentManager } from '../hooks/use-comment-manager';
import TextStyle from '@tiptap/extension-text-style';
import { CustomTextStyle } from '../extensions/custom-text-style';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledLayout = styled.div.withConfig({
  displayName: "editor-comment-view-onlycomponent__StyledLayout",
  componentId: "sc-1ibl2x0-0"
})([".tiptap{margin-bottom:", ";}.my-comment{position:relative;padding-right:", ";cursor:pointer;&::after{content:'\u270E';position:absolute;right:-14px;top:-8px;transform:translate(0,-50%) rotate(90deg);font-size:", ";line-height:1;border-radius:25%;border:1px solid ", ";color:", ";padding:1px;z-index:1;background:white;}}custom-class{background-color:", ";}.ProseMirror{padding:", ";border:", " solid ", ";border-top:none;border-bottom-left-radius:", ";border-bottom-right-radius:", ";outline:none !important;img{max-width:100%;}}p.is-editor-empty:first-child::before{color:", ";font-style:italic;content:attr(data-placeholder);float:left;height:0;pointer-events:none;}"], styleVariables.margin.large, styleVariables.padding.small, styleVariables.font.fontSizeSupport, function (props) {
  return props.theme.color.borderPrimary;
}, function (props) {
  return props.theme.color.fontColorDefault;
}, function (props) {
  return props.theme.color.primary;
}, styleVariables.padding.large, styleVariables.borderWidth.small, function (props) {
  return props.theme.color.borderPrimary;
}, styleVariables.borderRadius.medium, styleVariables.borderRadius.medium, function (props) {
  return props.theme.color.borderDefault;
});
var StyledEditorContent = styled(EditorContent).withConfig({
  displayName: "editor-comment-view-onlycomponent__StyledEditorContent",
  componentId: "sc-1ibl2x0-1"
})(["max-height:", ";overflow-y:", ";& > *{pointer-events:none;}.my-comment{pointer-events:auto;}"], function (props) {
  return props.scrollable ? '70vh' : 'none';
}, function (props) {
  return props.scrollable ? 'auto' : 'visible';
});
var StyledViewOnlyPopup = styled.div.withConfig({
  displayName: "editor-comment-view-onlycomponent__StyledViewOnlyPopup",
  componentId: "sc-1ibl2x0-2"
})(["position:fixed;z-index:1000;padding:", ";background:white;border:1px solid ", ";border-radius:", ";box-shadow:0 4px 12px rgba(0,0,0,0.15);max-width:350px;min-width:250px;h4{margin:0 0 ", " 0;font-size:", ";font-weight:", ";color:", ";}p{margin:0;font-size:", ";color:", ";white-space:pre-wrap;word-break:break-word;line-height:1.4;}"], styleVariables.padding.large, function (props) {
  return props.theme.color.borderPrimary;
}, styleVariables.borderRadius.medium, styleVariables.margin.medium, styleVariables.font.fontSizeSmall, styleVariables.font.fontWeightStrong, function (props) {
  return props.theme.color.fontColorDefault;
}, styleVariables.font.fontSizeSupport, function (props) {
  return props.theme.color.fontColorDefault;
});
export var EditorCommentViewOnly = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var content = _ref.content,
      _ref$scrollable = _ref.scrollable,
      scrollable = _ref$scrollable === void 0 ? false : _ref$scrollable,
      comments = _ref.comments,
      labels = _ref.labels;

  var _useCommentManager = useCommentManager({
    comments: comments,
    setComments: function setComments() {}
  }),
      hoveredCommentId = _useCommentManager.hoveredCommentId,
      popupPosition = _useCommentManager.popupPosition,
      commentValue = _useCommentManager.commentValue,
      handleCommentActivated = _useCommentManager.handleCommentActivated,
      handleCommentEditClick = _useCommentManager.handleCommentEditClick;

  var editor = useEditor({
    extensions: [StarterKit, Underline, TextStyle, CustomTextStyle, CommentExtension.configure({
      HTMLAttributes: {
        "class": 'my-comment'
      },
      onCommentActivated: handleCommentActivated
    })],
    content: content || '',
    editable: false
  });
  useEffect(function () {
    if (!editor) return;
    return function () {
      return editor.destroy();
    };
  }, [editor]);
  useEffect(function () {
    var timer = setTimeout(function () {
      var commentElements = document.querySelectorAll('[data-comment-id]');
      commentElements.forEach(function (element) {
        element.addEventListener('click', handleCommentEditClick);
      });
    }, 100);
    return function () {
      clearTimeout(timer);
      var commentElements = document.querySelectorAll('[data-comment-id]');
      commentElements.forEach(function (element) {
        element.removeEventListener('click', handleCommentEditClick);
      });
    };
  }, [content, comments, handleCommentEditClick]);
  return /*#__PURE__*/_jsxs(StyledLayout, {
    ref: ref,
    children: [/*#__PURE__*/_jsx(StyledEditorContent, {
      editor: editor,
      scrollable: scrollable
    }), hoveredCommentId && commentValue && popupPosition && /*#__PURE__*/_jsxs(StyledViewOnlyPopup, {
      style: {
        top: popupPosition.top + 10,
        left: popupPosition.left + 10
      },
      children: [/*#__PURE__*/_jsx("h4", {
        children: labels.comment
      }), /*#__PURE__*/_jsx("p", {
        children: commentValue
      })]
    })]
  });
});
EditorCommentViewOnly.displayName = 'EditorCommentViewOnly';